import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles(({
  breakpoints,
  fontWeights,
}: Theme) => ({
  tooltip: {
    padding: '1rem',
    borderRadius: '0.5rem',
  },
  tooltipContent: {
    margin: 0,
    fontSize: '0.75rem',
  },
  title: {
    display: 'flex',
    gap: '0.75rem',
    justifyContent: 'center',
    width: '100%',
    margin: '0 0 2rem',
    fontSize: '1.25rem',
    lineHeight: 1.4,
    fontWeight: fontWeights.medium,
    [breakpoints.up('sm')]: {
      marginBottom: 28,
      fontSize: '1.75rem',
      lineHeight: 1.35,
      justifyContent: 'flex-start',
    },
    '& > button': {
      position: 'absolute',
      right: 0,
      [breakpoints.up('sm')]: {
        position: 'static',
      },
    },
  },
}));
